module.exports = __webpack_public_path__ + "static/media/Banner2_new.b5444bbc.png";